/* src/app/features/player/components/player-events/player-events.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
.events-wrapper {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.events-wrapper .animate-icon {
  animation: status-change 1s ease-in-out forwards;
  pointer-events: none;
}
@keyframes status-change {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  20% {
    opacity: 1;
    transform: scale(1);
  }
  80% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}
/*# sourceMappingURL=player-events.component.css.map */
